import React from 'react';
import { Column, cls, Heading } from '../../../packages/components';
import EventTag from '../../PersistentMiniEpg/EventTag';
import EpgPersistence from '../../../AAF/Nepg/EpgPersistence';
import { Dates } from '../../../packages/dates/lib/dates';
import Utils from '../../../utils/Utils';



const getDescription = (dataEvent) => {
    const description = (dataEvent && dataEvent.description) || '';
    const cutDes = Utils.cutPlayerString(description, 290);
    return cutDes;
};

const getTitle = (dataEvent) => {
    let title = (dataEvent && (dataEvent.name || dataEvent.title)) || '';
    title = (title === 'NA' || !title) ? EpgPersistence.getLabelNotAvailable() : title;
    const cutTitle = Utils.cutPlayerString(title, 32);
    return cutTitle;
};

const getDate = (date_begin, date_end) =>{
    const result =  `${ EpgPersistence.needsOffset()? new Dates().unix(date_begin).utcOffset(EpgPersistence.needsOffset(),false).format('HH.mm') : new Dates().unix(date_begin).format('HH.mm')}hs a ${ EpgPersistence.needsOffset()? new Dates().unix(date_end).utcOffset(EpgPersistence.needsOffset(),false).format('HH.mm') : new Dates().unix(date_end).format('HH.mm')}hs`;
    return result;
}

const ResumenEvent = ({ event, streamContentType = null}) => {
    const {date_begin = null, date_end=null, duration=null, contentSerieEpisodeTitle = null}  = event;

    return (
        <Column lg={12} className={cls(`aaf-main-modal-options-col-content`, `${streamContentType ? `aaf-main-modal-options-col-content-${streamContentType}`: ''}`, `${contentSerieEpisodeTitle ? `aaf-main-modal-options-col-content-${streamContentType}-isSerie`: ''}`)}>
            <Heading size={1} className={cls(`aaf-main-modal-options-title`)}>
                {getTitle(event)}
            </Heading>
            { contentSerieEpisodeTitle && 
                <Heading size={5} className={cls(`aaf-main-modal-options-title-serie`)}>
                    {contentSerieEpisodeTitle}
                </Heading>
            }
            {
                date_begin && date_end && 
                <Column className={cls('modal_event_tag_event_column')}>
                    <EventTag wrapperId={'modal_1'}  spanId = {'modal_span_id'} startTime={date_begin}  endTime={date_end}/> 
                </Column>
            } 
            {date_begin && date_end &&<span size={1} className={cls(`aaf-main-modal-options-hour aaf-main-modal-options-left`)}>
                {getDate(date_begin, date_end)}
            </span>}
            {duration && <span size={1} className={cls(`aaf-main-modal-options-hour`, (date_begin && date_end ? `aaf-main-modal-options-right`: ''))}>
                {Utils.formatDuration(duration)}
            </span>}
            <Heading size={2} className={cls(`aaf-main-modal-options-desc`)}>
                {getDescription(event)}
            </Heading>
        </Column>
    );
};

export default ResumenEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/ResumenEvent.jsx